export default "__VITE_ASSET__jFLKAXx9__"